import React from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import Login from '../auth/Login'
import CallbackPage from '../auth/CallbackPage'
import userManager from '../utils/userManager'
import { LANDINGPAGE } from '../utils/constants'

const PrivateRoute = ({ component: Component, ...props }) => {
  if (process.env.NODE_ENV !== 'prod') {
    console.log('RoutesModuleProps: ' + JSON.stringify(props))
  }
  if (props.user && !props.user.expired) {
    // Set the authorization header for axios
    axios.defaults.headers.common.Authorization = 'Bearer ' + props.user.access_token
  }
  // wait for user to be loaded, and location is known
  if (props.isLoadingUser || !props.location) {
    return <span>Loading...</span>
  }
  // if location is callback page, return only CallbackPage route to allow signin process
  // IdentityServer 'bug' with hash history: if callback page contains a '#' params are appended with no delimiter
  // eg. /callbacktoken_id=...
  const urlPrefixlength = `${LANDINGPAGE}`.length + 10
  const url = props.location.pathname.substring(0, urlPrefixlength)
  if (url === `/${LANDINGPAGE}/callback`) {
    const rest = props.location.pathname.substring(urlPrefixlength)
    return <CallbackPage {...props} signInParams={`${url}#${rest}`} />
  }
  // check if user is signed in
  userManager.events.addUserLoaded(_ => {
    userManager.getUser()
      .then(resp => {
        if (resp && !resp.expired) {
          // Set the authorization header for axios
          axios.defaults.headers.common.Authorization = 'Bearer ' + resp.access_token
        }
      })
  })

  userManager.events.addSilentRenewError(function (error) {
    if (error.message == 'login_required') {
      userManager.signinRedirect({
        data: { path: props.location.pathname }
      })
    }
  })

  const isConnected = !!props.user

  return (
    !isConnected
      ? <Login path={props.location.pathname + props.location.search} />
      : <Route
        {...props} render={props => (
          <Component {...props} />
        )}
      />
  )
}

function mapStateToProps (AppState) {
  return {
    user: AppState.oidc.user,
    isLoadingUser: AppState.oidc.isLoadingUser,
    location: AppState.router.location
  }
}

function mapDispatchToProps (Dispatch) {
  return {
    Dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute)
